<template>
  <div class="setting tab-wrap">
    <setting-nav></setting-nav>
    <router-view class="article"></router-view>
  </div>
</template>
<script>
// import { mapState } from "vuex";
import settingNav from './sidebarnew'
// import { mapGetters, mapState } from 'vuex';
export default {
  components: {
    settingNav,
  },
  data () {
    return {
      // isUnfold: true,
      // activeTab:null
    }
  },
  created () {
    if (this.$store.state.user.role == 1 || this.$store.state.user.role == 2 || this.$store.state.user.role == 3) {
      // this.$router.push({ path: "/adminNew/setting", query: { tab: this.$route.query.tab } })
        let val = sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false;
        if(this.$store.state.user.role == 2&&val){
          var arr = sessionStorage.getItem("firstPageArr")?JSON.parse(sessionStorage.getItem("firstPageArr")):[]
          var arrElse = sessionStorage.getItem("secPageArr")?JSON.parse(sessionStorage.getItem("secPageArr")):[]
            if(arr.includes('default_firmware_upgrade')){
              this.$router.push({ path: "/adminNew/setting/firmware", query: { tab: this.$route.query.tab } })
            }else if(arr.includes('recharge_settings')){
              if(arrElse.includes('data_recharge')){
                this.$router.push({ path: "/adminNew/setting/rechargePay", query: { tab: this.$route.query.tab } })
              }else if(arrElse.includes('recharge_records')){
                this.$router.push({ path: "/adminNew/setting/rechargeRecord", query: { tab: this.$route.query.tab } })
              }else{
                this.$router.push({ path: "/adminNew/setting", query: { tab: this.$route.query.tab } })
              }
            }else{
                this.$router.push({ path: "/adminNew/setting", query: { tab: this.$route.query.tab } })
              }
        }else{
            this.$router.push({ path: "/adminNew/setting", query: { tab: this.$route.query.tab } })
        }
    } else {
      if (!this.$route.path === "/generalNew/setting/rechargePay") {
        this.$router.push({ path: "/generalNew/setting", query: { tab: this.$route.query.tab } })
      }

    }
    // this.activeTab = this.menuList.personal.title
  },
  // methods: {
  //   activeNav(tab){
  //     this.activeTab = tab.title
  //     if(this.$store.state.user.role == 1||this.$store.state.user.role == 2||this.$store.state.user.role == 3){
  //     this.$router.push(`/admin/setting/${tab.path}`)
  //   }else{
  //     this.$router.push(`/general/setting/${tab.path}`)
  //   }
  //   },
  //   handleSetCommand(command) {
  //     switch (command.type) {
  //       case this.$t('menu.personal'):
  //         this.activeTab = this.$t('menu.personal');
  //         this.activeNav(command.params)
  //         break;
  //       case this.$t('menu.recharge'):
  //         this.activeTab = this.$t('menu.recharge');
  //         this.activeNav(command.params)
  //         break;
  //       case this.$t('menu.rate'):
  //         this.activeTab = this.$t('menu.rate');
  //         this.activeNav(command.params)
  //         break;
  //       case this.$t('menu.firmware'):
  //         this.activeTab = this.$t('menu.firmware');
  //         this.activeNav(command.params)
  //         break;
  //       case this.$t('menu.customize'):
  //         this.activeTab = this.$t('menu.customize');
  //         this.activeNav(command.params)
  //         break;
  //       default:
  //         break;
  //     }
  //   },
  //   // folding() {
  //   //   if (this.isUnfold) {
  //   //     this.isUnfold = !this.isUnfold;
  //   //   } else {
  //   //     this.isUnfold = !this.isUnfold;
  //   //   }
  //   // }
  // },
  computed: {
    // ...mapGetters({
    //   deviceInfo: 'getDeviceInfo'
    // }),
    // ...mapState({
    //   menuList: state => {
    //     let route = state.user.route.find(route => {
    //       return route.path.endsWith("setting");
    //     });
    //     // console.log('【route-index】', route);
    //     let menu = {};
    //     route.children.forEach(ele => {
    //       if (!ele.meta) return

    //       // 过滤掉个人信息路由 =====
    //       if (ele.path == 'personalBasic') return

    //       // 若为子路由，添加到父路由中
    //       let category = ele.meta.category;
    //       if (category) {
    //         // 尚未父路由，先创建
    //         if (!menu[category]) {
    //           menu[category] = {
    //             ...route.meta.category[category],
    //             path: ele.path
    //           };
    //         }
    //         // menu[category].submenu.push({
    //         //   name: ele.name,
    //         //   title: ele.meta.title
    //         // })
    //       } else {
    //         // 否则直接添加到路由表中
    //         menu[ele.name] = {
    //           ...ele.meta,
    //           path: ele.path
    //         };
    //       }
    //     });
    //     if(window.document.location.hostname == 'tgpropower.dessmonitor.com'){
    //       if(menu.recharge) delete menu.recharge
    //       if(menu.adminCustomize) delete menu.adminCustomize
    //     }
    //     return menu;
    //   }
    // }),
  },
}
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.adminHome {
  flex: 1;
  display: flex;
  align-items: stretch;

  .article {
    flex: 1;
    overflow: hidden;
  }
}

.activeTabGroup {
  background: @siderbarColor;
  margin-left: 30px;
}

.activeTabGroupItem {
  // background: #1890ff;
  color: #ffffff;
  border: none;
  margin: 5px 0;

  &:not(:last-child) {
    border-bottom: none;
  }

  &.active {
    background: @themeColor;
  }

  &:hover,
  &:focus {
    background: @themeColor;
    color: #ffffff;
  }
}

.iconfont {
  display: inline-block;
  font-size: 24px;
}

.asideOut {
  // width: 256px !important;
  width: 306px !important;
  transition: all 0.3s linear 0s;
}

.asideIn {
  width: 80px !important;
  transition: all 0.3s linear 0s;
}

.anniu {
  font-size: 28px;
  color: #ffffff;
  cursor: pointer;

  &:hover,
  &:focus {
    color: @themeColor;
  }
}

// Loading
.el-loading-spinner .path {
  stroke: @primaryTextColor !important;
}</style>
<style lang="less">body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  // font-weight: 100;
  font-family: Microsoft YaHei;
}</style>
